import { render } from "./Footer.vue?vue&type=template&id=4763eedf&scoped=true&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=4763eedf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4763eedf"]])

export default __exports__